import { reservedSpaceHeader, pixelsPerRem } from "./mediaConstants";

export const expandAccordion = (element) => {
  //if the element is inside an accordion, then open the accordion
  const accordionControlToggle = element
    ?.closest("[data-element='accordion']")
    ?.getElementsByTagName("button")[0];
  if (
    accordionControlToggle &&
    accordionControlToggle.getAttribute("data-accordion-state") === "false"
  ) {
    accordionControlToggle.click();
    return true;
  }

  return false;
};

export const scrollToElementById = (
  id,
  isHeaderFixed,
  isMobile,
  isTablet,
  overrideOffset = 0
) => {
  const element = document.getElementById(id);
  if (element) {
    expandAccordion(element);
    setTimeout(() => {
      const topOfElement = element.getBoundingClientRect().top;

      let offsetElementPosition =
        topOfElement + window.scrollY - overrideOffset + 1;

      let offset = reservedSpaceHeader.lg * pixelsPerRem;

      if (isMobile) {
        offset = reservedSpaceHeader.sm * pixelsPerRem;
      }
      if (isTablet) {
        offset = reservedSpaceHeader.md * pixelsPerRem;
      }

      offsetElementPosition -= offset;
      window.scrollTo(0, Math.ceil(offsetElementPosition));
    }, 0);
  }
};

export const scrollToElement = (
  elem,
  offset = 0,
  smooth = false,
  scrolledParent = window
) => {
  const topOfElement = elem.getBoundingClientRect().top;
  const parentOffset = scrolledParent === window ? window.scrollY : 0;
  const offsetElementPosition = topOfElement + parentOffset - offset;
  if (smooth) {
    scrolledParent.scrollTo({
      left: 0,
      top: offsetElementPosition,
      behavior: "smooth",
    });
  } else {
    scrolledParent.scrollTo(0, offsetElementPosition);
  }
};

export const setHash = (referenceHash, pathname, history) => {
  const route = {
    pathname,
    hash: referenceHash?.slice(1) ? `${referenceHash}` : undefined,
  };
  if (history?.location?.hash !== `${referenceHash}`) {
    history.push(route, history.location.state);
  }
};
